import type { Favourite } from "@outverse-video/outverse-api-client-lib";
import { writable } from "svelte/store";
import api from "$utils/api";
import { apiReady } from "./auth";

type FavouriteObjectType = "forum" | "thread" | "doc";

const favouritesStore = () => {
  const { subscribe, set } = writable<Favourite[]>([]);
  let currentCommunity = "";

  const fetch = async (communitySlug: string) => {
    if (currentCommunity !== communitySlug) {
      currentCommunity = communitySlug;
      set([]);
    }
    await apiReady;
    api.communitiesFavouritesList({ communitySlug }).then((resp) => {
      set(resp.data.results || []);
    });
  };
  return {
    subscribe,
    fetch,
    add: async ({ uuid, type }: { uuid: string; type: FavouriteObjectType }) => {
      if (type === "forum") {
        await api.forumSpaceFavourite({ uuid });
      } else if (type === "doc") {
        await api.communitiesDocumentsFavourite({
          uuid,
          communitySlug: currentCommunity,
        });
      }
      await fetch(currentCommunity);
    },
    remove: async ({ uuid, type }: { uuid: string; type: FavouriteObjectType }) => {
      if (type === "forum") {
        await api.forumSpaceUnfavourite({ uuid });
      } else if (type === "doc") {
        await api.communitiesDocumentsUnfavourite({
          uuid,
          communitySlug: currentCommunity,
        });
      }
      await fetch(currentCommunity);
    },
  };
};

export const favourites = favouritesStore();
